import { CancellationIdCardForm as TypeCancellationIdCardForm } from 'front-office/pages/cancellation-id-card/cancellation';
import { Fragment } from 'react';
import EditData from './edit-data';
import AccordionIdentityCard from './id-card';
import AccordionPerson from './person';

interface CancellationIdCardFormProps {
  form: TypeCancellationIdCardForm;
}

const CancellationIdCardForm = ({ form }: CancellationIdCardFormProps): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson form={form.personStep} />
      <EditData form={form.editDataControl} />
      <AccordionIdentityCard form={form.identityCard} />
    </Fragment>
  );
};

CancellationIdCardForm.displayName = 'Cancellation id card form component';

export default CancellationIdCardForm;
